/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from '@glimmer/component';
import DOMPurify from 'dompurify';
import { htmlSafe } from '@ember/template';
export default class SafeHtml extends Component {
  get safeHtml() {
    return htmlSafe(DOMPurify.sanitize(this.args.html ?? ''));
  }
}